export default __webpack_public_path__ + "2e421b4156f446800ca1156e6fb5935b.svg";